import { Box, useTheme } from "@mui/material";
import styles from "./UserChatMessage.module.css";

interface Props {
    message: string;
}

export const UserChatMessage = ({ message }: Props) => {
    const theme = useTheme();
    return (
        <Box overflow={"visible"} className={styles.container}>
            <Box sx={{ color: theme.palette.text.primary, backgroundColor: theme.palette.userMessageBG }} className={styles.message}>
                {message}
            </Box>
        </Box>
    );
};
